import { render, staticRenderFns } from "./NewZoneIpt.vue?vue&type=template&id=5edf7d10&scoped=true&"
import script from "./NewZoneIpt.vue?vue&type=script&lang=js&"
export * from "./NewZoneIpt.vue?vue&type=script&lang=js&"
import style0 from "./NewZoneIpt.vue?vue&type=style&index=0&id=5edf7d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf7d10",
  null
  
)

export default component.exports